import builder from '../builder';
import CarGarage from '../../streamline-icons/bold/car-garage.svg';

export default builder('IconCarGarageBold', CarGarage);
